import React, { useState } from 'react';
import { Plus, RefreshCw, Building2, Calendar } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import api from '../../services/api';
import { toast } from 'sonner';

export default function FinancialHeader({
  title,
  subtitle,
  ownerCompanyId,
  setOwnerCompanyId,
  ownerCompanies = [],
  onNewTransaction,
  onRefresh,
}) {
  const [syncing, setSyncing] = useState(false);

  const handleSync = async () => {
    setSyncing(true);
    try {
      const res = await api.post('/financial/sync');
      const counts = res.data?.data || res.data || {};
      const total = (counts.contracts || 0) + (counts.licenses || 0) + (counts.documents || 0) + (counts.maintenance || 0) + (counts.fuel || 0);
      toast.success(`Sincronização concluída! ${total} registros sincronizados (Contratos: ${counts.contracts || 0}, Licenças: ${counts.licenses || 0}, OS: ${counts.maintenance || 0}, Abastecimento: ${counts.fuel || 0})`);
      if (onRefresh) onRefresh();
    } catch {
      toast.error('Erro ao sincronizar módulos financeiros');
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6 pb-4 border-b border-neutral-200 dark:border-neutral-800">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-neutral-900 dark:text-neutral-100">{title}</h1>
        {subtitle && <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5">{subtitle}</p>}
      </div>

      <div className="flex flex-wrap items-center gap-2.5">
        {/* Seletor de Empresa / CNPJ */}
        <div className="flex items-center gap-1.5 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-lg px-2.5 py-1">
          <Building2 className="h-4 w-4 text-neutral-400 shrink-0" />
          <span className="text-xs font-medium text-neutral-500 whitespace-nowrap">Empresa:</span>
          <Select value={ownerCompanyId || 'all'} onValueChange={setOwnerCompanyId}>
            <SelectTrigger className="border-0 shadow-none h-7 text-xs font-semibold focus:ring-0 p-0 pr-2">
              <SelectValue placeholder="Todas as Empresas" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Visão Consolidada (Todas)</SelectItem>
              {ownerCompanies.map(c => (
                <SelectItem key={c.id} value={c.id}>
                  {c.name} {c.cnpj ? `(${c.cnpj})` : ''}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Botão Sincronizar Módulos */}
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={handleSync}
          disabled={syncing}
          className="h-9 text-xs gap-1.5"
          title="Sincronizar receitas de contratos, licenciamentos, manutenções e combustível"
        >
          <RefreshCw className={`h-3.5 w-3.5 ${syncing ? 'animate-spin text-brand' : ''}`} />
          {syncing ? 'Sincronizando...' : 'Sincronizar'}
        </Button>

        {/* Botão de Destaque "+ Novo Lançamento" */}
        {onNewTransaction && (
          <Button
            type="button"
            onClick={onNewTransaction}
            className="h-9 bg-brand hover:bg-[#A81E23] text-white text-xs font-semibold shadow-sm gap-1.5"
          >
            <Plus className="h-4 w-4" />
            + Novo lançamento
          </Button>
        )}
      </div>
    </div>
  );
}
